/** @jsx jsx */
import { jsx } from "@emotion/core";
import ChannelTitle from "../ChannelTitle";
import FeedItemSummary from "../FeedItemSummary";
import { entry } from "../FeedStyles";
import Parser from "html-react-parser";

const ImagePost = ({
    post: {
        id,
        imageUrl,
        name,
        description,
        channel,
        publicationDate,
        isFavourite,
        numComments,
        isLiked,
        numberOfLikes,
        author,
        kind,
        article,
    },
}) => (
    <div css={entry.post}>
        <ChannelTitle
            channel={channel}
            author={author}
            postId={id}
            {...{ publicationDate, isFavourite }}
        />
        {name && name != " " && <div css={entry.title}>{name}</div>}
        <div css={entry.imageWrapper}>
            <img alt="" src={imageUrl} css={entry.img} />
        </div>
        <div css={entry.text}>{description && Parser(description)}</div>
        <FeedItemSummary
            postId={id}
            postName={description
                .replace(/<[^>]+>/g, " ")
                .replace(/\s\s+/g, " ")
                .trim()
                .split(/\s+/)
                .slice(0, 10)
                .join(" ")
                .concat([" ..."].join(""))}
            channel={{ id: channel.id, name: channel.name }}
            {...{ isFavourite, numComments, isLiked, numberOfLikes, kind, article, imageUrl }}
        />
    </div>
);

export default ImagePost;
